module.exports = __webpack_public_path__ + "static/media/animated_ashutosh.98ff2c6d.jpg";